var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 272,
    viewBox: "0 0 585 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    id: "path-m",
    d: "M583.312 78.5834C586.652 95.4467 581.743 113.137 569.962 130.7C558.18 148.265 539.534 165.686 515.44 181.993C467.251 214.606 397.309 242.734 317.035 258.634C236.762 274.535 161.378 275.193 104.396 263.412C75.9048 257.522 52.0262 248.524 34.4382 236.777C16.8513 225.031 5.5695 210.548 2.2292 193.685C-1.11111 176.821 3.7978 159.131 15.5791 141.568C27.3612 124.003 46.0066 106.582 70.1012 90.2754C118.29 57.6622 188.232 29.5341 268.506 13.6334C348.779 -2.2673 424.163 -2.92534 481.145 8.85563C509.636 14.7462 533.515 23.7441 551.103 35.4909C568.69 47.2369 579.972 61.72 583.312 78.5834Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/m.ed3e1bc8.svg";
export { ForwardRef as ReactComponent };